module.exports = __webpack_public_path__ + "static/img/rank_19.49a0670.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_19.png
// module id = sKD8
// module chunks = 1